// Translations
import landing from '../views/landing/translations/en'

// Translation: Two-factor authentication (English)
export default Object.freeze({
	name: 'Two-factor authentication activation',
	views: { landing }
})
